import { Box, Grid, Typography } from "@mui/material";
import Service from "./components/Service/Service";
import { services } from "../../../../constants/services";
import FadeInBox from "../../../../commonComponents/FadeInBox";

const Services = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: 2,
        pl: { xs: 4, md: 15 },
        pr: { xs: 4, md: 15 },
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: "25px",
          fontWeight: 700,
          fontFamily: "Montserrat",
          textAlign: { xs: "center", md: "inherit" },
        }}
      >
        Our Services
      </Typography>

      <Grid container spacing={2}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <FadeInBox
              delay={0.2 * index}
              triggerOnScroll={true}
              triggerOnMount={false}
            >
              <Service key={index} service={service} />
            </FadeInBox>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default Services;
